import { render, staticRenderFns } from "./sidebar-page-content-wrapper.vue?vue&type=template&id=6e8754c7&scoped=true&"
import script from "./sidebar-page-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./sidebar-page-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-page-content-wrapper.vue?vue&type=style&index=0&id=6e8754c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8754c7",
  null
  
)

export default component.exports